<template>
    <section class="products-categories" v-if="result.items.length > 0">
        <DefTitle :result="2">
            <h2>
                {{ result.messages.title }}
            </h2>
        </DefTitle>
        <!--        :nav="screenWidth >= 992"-->
        <DefSlider
            :nav="true"
            :pagination="true"
            :settings="settings"
            ref="slider"
        >
            <div
                v-for="item in result.items"
                :key="item.offer && item.offer.id || item.id"
                class="swiper-slide"
            >
                <SliderCard :result="item" />
            </div>
        </DefSlider>
    </section>
</template>

<script>
import { mapState } from 'vuex';
import DefTitle from "../Def/DefTitle/DefTitle.vue";
import DefSlider from "../Def/DefSlider/DefSlider.vue";
import SliderCard from "../card/SliderCard/SliderCard.vue";
export default {
    name: "ProductsСategories",
  components: {SliderCard, DefSlider, DefTitle},
    selector: '.products-categories',
    props: ['result'],
    data() {
      return {
        settings: {
          slidesPerView: 2,
          spaceBetween: 0,
          autoplay: {
            delay: 5000,
          },
          pagination: {
            el: null, // Явно указываем, что пагинация отсутствует
          },
          breakpoints: {
            992: {
              slidesPerView: 4,
              spaceBetween: 0,
              autoplay: false,
            },
          }
        },
      }
    }
}
</script>

<style lang="scss" scoped>
.def-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 23px;
  h2 {
    color: #333;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    border: none;
    background-color: transparent;
    padding: 0 40px;
    cursor: pointer;
    transition: color .2s linear;
  }
}

.products-categories{
  :deep(.slider-card){
    border: 1px solid #f5efef;
  }
  ::v-deep{
    .slider-card {
      @include point-lg{
        border-top: 1px solid #e0dbd5;
        border-right: 1px solid #e0dbd5;
        border-bottom: 1px solid #e0dbd5;
        height: 100%;
      }
    }
    @media (max-width: 992px) {
      .slider-card {
        border: none;
      }
      .def-slider__next{
        right: 0;
      }
      .def-slider__prev{
        left: 0;
      }
    }
  }
}
</style>